/**
 * Starts the third-party transports, once, from the composition root (#112).
 *
 * **Fire and forget, and total.** Telemetry is the one thing in this app whose
 * absence is always acceptable, so every failure path here ends in "carry on":
 * a missing credential, a blocked script, an unsupported browser, a module that
 * fails to load.
 *
 * **Takes its inputs rather than reading them.** `platform/` may not import
 * `auth/` or read `config/`, so `main.tsx` — which already owns both — passes
 * the DSN, the mode, and a thunk that starts analytics (undefined when there is
 * no measurement id). Both SDKs are imported dynamically, so with neither
 * credential — today's state in every environment — no vendor code is fetched.
 */
export type TelemetryInputs = {
  sentryDsn: string | undefined
  mode: string
  startAnalytics: (() => Promise<unknown>) | undefined
}

export function startTelemetry(inputs: TelemetryInputs): void {
  void startSentry(inputs)
  void startAnalytics(inputs)
}

async function startSentry({ sentryDsn, mode }: TelemetryInputs): Promise<void> {
  try {
    if (!sentryDsn) return
    const { initSentry } = await import('./sentry')
    await initSentry(sentryDsn, mode)
  } catch {
    // see header
  }
}

async function startAnalytics({ startAnalytics: start }: TelemetryInputs): Promise<void> {
  try {
    await start?.()
  } catch {
    // see header
  }
}
